export default {
  default: () => import("/var/www/mj_client/releases/20251113081132/layouts/default.vue").then(m => m.default || m),
  simple: () => import("/var/www/mj_client/releases/20251113081132/layouts/simple.vue").then(m => m.default || m)
}